module.exports = __webpack_public_path__ + "static/media/iStock-1185282377.8ebd9f4e.jpg";